/**
 * Converts hex color to RGB array for PDF (jsPDF autoTable)
 * @param hex - Hex color string (e.g., "#FF0000" or "FF0000")
 * @returns RGB array [r, g, b]
 */
export function hexToRgb(hex: string): [number, number, number] {
  if (!hex) {
    return [0, 0, 0];
  }

  // Remove # if present
  const cleanHex = hex.replace('#', '');

  // Validate hex string
  if (!/^[0-9A-Fa-f]{6}$/.test(cleanHex)) {
    // eslint-disable-next-line no-console
    console.warn(`Invalid hex color: ${hex}, using black`);
    return [0, 0, 0];
  }

  const result = /^([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(cleanHex);
  return result
    ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)]
    : [0, 0, 0];
}

/**
 * Converts hex color to BGR string for Excel (XLSX uses Blue-Green-Red format)
 * @param hex - Hex color string (e.g., "#FF0000" or "FF0000")
 * @returns BGR hex string (e.g., "0000FF" for red)
 */
export function hexToBgr(hex: string): string {
  if (!hex) {
    return '000000';
  }

  // Remove # if present
  const cleanHex = hex.replace('#', '');

  // Validate hex string
  if (!/^[0-9A-Fa-f]{6}$/.test(cleanHex)) {
    // eslint-disable-next-line no-console
    console.warn(`Invalid hex color: ${hex}, using black`);
    return '000000';
  }

  // Convert RGB to BGR and format as hex string
  const r = cleanHex.substring(0, 2);
  const g = cleanHex.substring(2, 4);
  const b = cleanHex.substring(4, 6);

  // Excel uses BGR format, so reverse the order
  return `${b}${g}${r}`.toUpperCase();
}
